<template>
  <div class="frame">
    <div class="container">
      <div class="row no-gutters">
        <div class="col">
          <h1>{{ $t("calculationoutput.introHeader") }}</h1>
          <p>
            {{ $t("calculationoutput.introText") }}
          </p>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col">
          <table class="c calculation-result">
            <tbody>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.roofElementType") }}
                </template>
                <template v-slot:value>
                  {{ roofElementType }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.amountUnidekRoofElements") }}
                </template>
                <template v-slot:value>
                  {{ totalRoofElements }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.surfacePerRoofElement") }}
                </template>
                <template v-slot:value>
                  {{ `${squaredMetersPerElementAsString} m²` }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.combipack") }}
                </template>
                <template v-slot:value>
                  {{ combipak }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.amountOfCombipacks") }}
                </template>
                <template v-slot:value>
                  {{ boxesOfScrews }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.screwSpacerCount") }}
                </template>
                <template v-slot:value>
                  {{ additionalScrewSpacerCount }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.ldProfilesCount") }}
                </template>
                <template v-slot:value>
                  {{ ldProfilesCount }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.geficellBandCount") }}
                </template>
                <template v-slot:value>
                  {{ geficellBandCount }}
                </template>
              </calculation-result-row>
              <calculation-result-row>
                <template v-slot:description>
                  {{ $t("calculationoutput.aerosafeFoamCannisterCount") }}
                </template>
                <template v-slot:value>
                  {{ aerosafeFoamCannisterCount }}
                </template>
              </calculation-result-row>
              <calculation-result-row v-if="!isCultureNl">
                <template v-slot:description>
                  {{ $t("calculationoutput.aerosafeFoamPistol") }}
                </template>
                <template v-slot:value>
                  {{ aerosafeFoamPistolValue }}
                </template>
              </calculation-result-row>
            </tbody>
          </table>
          <aside>
            <span class="text-muted text-italic d-block mb-2">
              {{ $t("calculationoutput.calculationDisclaimer") }}
            </span>
            <span class="text-muted text-italic d-block">
              {{ $t("calculationoutput.calculationExtraInfoOutro") }}
            </span>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calculationResultRow from "./CalculationResultRow";
import { mapGetters } from "vuex";

export default {
  name: "CalculationOutput",
  components: {
    calculationResultRow
  },
  computed: mapGetters([
    "roofElementType",
    "totalRoofElements",
    "squaredMetersPerElement",
    "combipak",
    "boxesOfScrews",
    "additionalScrewSpacerCount",
    "ldProfilesCount",
    "geficellBandCount",
    "aerosafeFoamCannisterCount",
    "squaredMetersPerElementAsString",
    "aerosafeFoamPistolValue",
    "isCultureNl"
  ])
};
</script>
